module.exports = __webpack_public_path__ + "img/pic_trialsus.5a044fcc.png";